import React from 'react'
import type { Message } from '../types'
import { renderMessageContent } from '../utils/render-message-content'
import { trackAffiliateClick } from '../utils/affiliate-tracking'

interface TranscriptProps {
  transcript: Message[]
  transcriptRef: React.RefObject<HTMLDivElement | null>
  /** Currently unused — trash button is hidden but prop kept for future restore */
  onClear?: () => void
  primaryColor: string
  publicKey?: string
  poweredByText?: string
  botName?: string
  /** Live streaming user partial (Phase B azure_speech) — shown as an ephemeral bubble. */
  livePartial?: string
}

export function Transcript({
  transcript,
  transcriptRef,
  primaryColor,
  publicKey,
  poweredByText,
  botName,
  livePartial,
}: TranscriptProps) {
  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <div
        style={{
          padding: '12px 16px',
          borderBottom: '1px solid #e5e7eb',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <span style={{ fontWeight: 500, color: '#374151' }}>שיחה</span>
          {poweredByText && (
            <span style={{ fontWeight: 500, color: primaryColor }}>{poweredByText}</span>
          )}
          {/* Trash button hidden — may be restored later
          <button
            onClick={onClear}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: '#9ca3af',
              padding: 4,
            }}
          >
            <Trash2 size={16} />
          </button>
          */}
        </div>
        <div
          style={{
            fontSize: 11,
            color: '#6b7280',
            marginTop: 8,
            textAlign: 'center',
            lineHeight: 1.4,
          }}
        >
          {(botName || 'הסוכנת')} עלולה לעשות טעויות. יש להיוועץ עם איש מקצוע בטרם קבלת החלטה.
        </div>
      </div>
      <div
        ref={transcriptRef}
        style={{
          flex: 1,
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
          padding: 16,
          backgroundColor: '#f9fafb',
        }}
      >
        {transcript.length === 0 && !livePartial ? (
          null
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {transcript.map((msg, idx) => (              <div
                key={idx}
                style={{
                  display: 'flex',
                  justifyContent: msg.role === 'user' ? 'flex-start' : 'flex-end',
                }}
              >
                <div
                  style={{
                    maxWidth: '80%',
                    padding: '10px 14px',
                    borderRadius: 12,
                    backgroundColor: msg.role === 'user' ? primaryColor : 'white',
                    color: msg.role === 'user' ? 'white' : '#374151',
                    border: msg.role === 'user' ? 'none' : '1px solid #e5e7eb',
                    fontSize: 14,
                    lineHeight: 1.5,
                    textAlign: 'right',
                    direction: 'rtl',
                  }}
                >
                  {renderMessageContent(msg.content, primaryColor, publicKey)}
                  {msg.links && msg.links.length > 0 && (
                    <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 4 }}>
                      {msg.links.map((link, linkIdx) => (
                        <a
                          key={linkIdx}
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => {
                            e.preventDefault()
                            window.open(link.url, '_blank', 'noopener,noreferrer')
                            if (publicKey) {
                              trackAffiliateClick(link.url, link.label, publicKey)
                            }
                          }}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 6,
                            padding: '6px 12px',
                            borderRadius: 8,
                            backgroundColor: primaryColor + '15',
                            border: `1px solid ${primaryColor}40`,
                            color: primaryColor,
                            fontSize: 13,
                            fontWeight: 500,
                            textDecoration: 'none',
                            direction: 'ltr',
                            transition: 'background-color 0.2s',
                          }}
                          onMouseEnter={(e) => { (e.target as HTMLElement).style.backgroundColor = primaryColor + '25' }}
                          onMouseLeave={(e) => { (e.target as HTMLElement).style.backgroundColor = primaryColor + '15' }}
                        >
                          🔗 {link.label}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
            {livePartial && (
              <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                <div
                  style={{
                    maxWidth: '80%',
                    padding: '10px 14px',
                    borderRadius: 12,
                    backgroundColor: primaryColor,
                    color: 'white',
                    opacity: 0.55,
                    fontSize: 14,
                    lineHeight: 1.5,
                    textAlign: 'right',
                    direction: 'rtl',
                    fontStyle: 'italic',
                  }}
                >
                  {livePartial}…
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
